export const getPaginationLinks = (currentPage, pagesAmount, searchParams, perPage) => {
  return `${
    currentPage >= 4
      ? `<li class="catalog__cards-pagination-item">
              <a href="${searchParams}&page=1&per-page=${perPage}" class="catalog__cards-pagination-link" data-page="1">1</a>
            </li><li class="catalog__cards-pagination-item">
              <span class="catalog__cards-pagination-link">…</span>
            </li>`
      : ``
  }
      ${
        currentPage === 3
          ? `<li class="catalog__cards-pagination-item">
              <a href="${searchParams}&page=1&per-page=${perPage}" class="catalog__cards-pagination-link" data-page="1">1</a>
            </li>`
          : ""
      }
          ${
            currentPage >= 2
              ? `<li class="catalog__cards-pagination-item">
              <a href="${searchParams}&page=${currentPage - 1}&per-page=${perPage}" class="catalog__cards-pagination-link" data-page="${
                  currentPage - 1
                }">${currentPage - 1}</a>
            </li>`
              : ""
          }

            <li class="catalog__cards-pagination-item">
              <a class="catalog__cards-pagination-link catalog__cards-pagination-link--active" data-page="${currentPage}">${currentPage}</a>
            </li>
            ${
              currentPage !== pagesAmount
                ? `<li class="catalog__cards-pagination-item">
              <a href="${searchParams}&page=${currentPage + 1}&per-page=${perPage}" class="catalog__cards-pagination-link" data-page="${
                    currentPage + 1
                  }">${currentPage + 1}</a>
            </li>`
                : ""
            }
            ${
              pagesAmount - currentPage >= 2
                ? `<li class="catalog__cards-pagination-item">
              <span class="catalog__cards-pagination-link">…</span>
            </li><li class="catalog__cards-pagination-item">
              <a href="${searchParams}&page=${pagesAmount}&per-page=${perPage}" class="catalog__cards-pagination-link" data-page="${pagesAmount}">${pagesAmount}</a>
            </li>`
                : ""
            }

            ${
              pagesAmount > 3 && currentPage !== pagesAmount
                ? `<li class="catalog__cards-pagination-item catalog__cards-pagination-item--next">
              <a href="${searchParams}&page=${
                    currentPage + 1
                  }&per-page=${perPage}" class="catalog__cards-pagination-link catalog__cards-pagination-link--next">Дальше</a>
            </li>`
                : ""
            }`;
};
